
<template>
  <div class="table-layout-wrap">
    <!-- 上边区域 -->
    <slot name="upActions" />

    <!-- 过滤器 + 回显 + 表格左右操作 -->
    <div v-if="!tableConfig.hideActionBox" class="actions-box">
      <slot name="formActions" />
      <!-- 有leftActions 另起一行 -->
      <div style="width: 100%" v-if="$slots.leftActions" />
      <div class="left-action" v-if="$slots.leftActions">
        <slot name="leftActions" />
      </div>
      <!-- 右边区域 -->
      <div
        class="sz-rightActions-box"
        :style="$slots.leftActions ? 'margin-top: 15px' : 'margin-top: 12px'"
      >
        <slot name="rightActions" />
        <!-- 刷新 -->
        <el-tooltip v-if="tableConfig.update" :open-delay="200" content="刷新" placement="top">
          <span @click="$sensors.setWebClick({ name: '表格点击-刷新' })">
            <HcButtonSvg
              class="inline-btn icon-button"
              @click="getData"
              svgIconClass="refresh-1"
              svgIconClassHover="refresh-1--hover"
            />
          </span>
        </el-tooltip>
        <!-- 下载 - 导出报告  -->
        <el-tooltip v-if="tableConfig.exportInfo && tableConfig.exportInfo.isHide !== true" :open-delay="200" content="导出报告" placement="top">
          <span @click="$sensors.setWebClick({ name: '表格点击-导出报告' })">
            <HcButtonSvg
              class="inline-btn icon-button"
              @click="tableConfig.exportInfo.exportFnc(2)"
              svgIconClass="download-report"
              svgIconClassHover="download-report--hover"
            />
          </span>
        </el-tooltip>
        <!-- 下载 生成报告 -->
        <el-tooltip v-if="tableConfig.exportInfo && tableConfig.exportInfo.isHide !== true" :open-delay="200" content="生成报告" placement="top">
          <span @click="$sensors.setWebClick({ name: '表格点击-生成报告' })">
            <HcButtonSvg
              class="inline-btn icon-button"
              @click="tableConfig.exportInfo.exportFnc(1)"
              svgIconClass="download-1"
              svgIconClassHover="download-1--hover"
            />
          </span>
        </el-tooltip>
        <!-- 帮助 -->
        <el-tooltip v-if="tableConfig.linkInfo" :open-delay="200" content="帮助文档" placement="top">
          <span @click="$sensors.setWebClick({ name: '表格点击-帮助' })">
            <a :href="tableConfig.linkInfo.path" target="_blank" >
              <HcButtonSvg
                class="inline-btn icon-button"
                svgIconClass="help" svgIconClassHover="help--hover"
              />
            </a>
          </span>
        </el-tooltip>
        <!-- 自定义列 -->
        <el-tooltip v-if="!tableConfig.hideCustomColSetting && tableConfig.customColumn" :open-delay="200" content="自定义列" placement="top">
          <span @click="$sensors.setWebClick({ name: '表格点击-自定义列' })">
            <HcButtonSvg
              class="inline-btn icon-button"
              @click="openHeaderDialog"
              svgIconClass="setting-1"
              svgIconClassHover="setting-1--hover"
            />
          </span>
        </el-tooltip>
        <template v-if="tableConfig.switchInfo && !tableConfig.switchInfo.hide">
          <HcToggleButton
            v-if="tableConfig.switchInfo.type === 'toggleButton'"
            v-model="tableConfig.switchInfo.value"
            :open-value="1"
            :open-label="tableConfig.switchInfo.openLabel"
            :close-value="0"
            :close-label="tableConfig.switchInfo.closeLabel"
          />

          <vxe-switch
            v-else
            v-model="tableConfig.switchInfo.value"
            :open-label="tableConfig.switchInfo.openLabel"
            :open-value="1"
            :close-label="tableConfig.switchInfo.closeLabel"
            :close-value="0"
          />
        </template>

        <slot name="rightActionsRight" />
      </div>
    </div>

    <!-- 下边碍于 -->
    <slot name="downActions" />

    <!-- vxe-grid 表格 -->
    <div v-if="!tableConfig.hideTable" class="flex-1 onHide" v-loading="loading">
      <vxe-grid
        ref="mainTable"
        v-bind="{
          data: tableData,
          height: 'auto',
          rowStyle: {
            height: `${tableConfig.rowHeight || 48}px`,
          },
          rowConfig: { useKey: tableConfig.rowSortable ? true : false },
          emptyRender: { name: `${tableConfig.noDataTemplate || 'NotData-big'}` },
          ...tableConfig.props,
          columns: columnsInner,
          headerCellStyle: composeVxeGridHeaderCellStyle,
          headerCellClassName: composeVxeGridHeaderCellClassName,
          cellClassName: composeVxeGridCellClassName,
          footerCellClassName: composeVxeGridFooterCellClassName,
        }"
        v-on="{
          ...tableConfig.methods,
          'checkbox-change': handleCheckboxChange,
          'checkbox-all': handleCheckboxAllChange,
          scroll: handleVxeGridScroll,
        }"
      >
        <slot name="tableEmpty" slot="empty"></slot>
      </vxe-grid>
    </div>

    <slot name="tableDownActions" />

    <!-- 页码 -->
    <div
      class="page-box"
      v-show="tableConfig.hidePagination !== true && page.total >= 0"
    >
      <div>
        <slot name="paginationLeftActions"></slot>
      </div>
      <div>
        <PageBtn
          :page="page"
          :selectedNum="tableCheckedRowsNum"
          :isShowSelectedNum="tableConfig.isShowSelectedNum"
          @page-change="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import PageBtn from './page-btn'
import SzEditTableHeader from './sz-edit-table-header'
import HcToggleButton from '@/components/HcToggleButton.vue'
// import { deepCopy } from '@/utils/deep-copy'
import { getAutoWidthFieldList, reComputeAutoWidth, transColumnFixClassName } from './utils/autoWidth'
import { isArray, isFunction, isString } from 'xe-utils'

import { deepHandleColBeforeRender } from './utils'
import debounce from 'lodash.debounce'
import HcButtonSvg from '@/components/HcButtonSvg.vue'

import Sortable from 'sortablejs'
import { composeFnObj, composeFnStrSpace, TABLE_HEADER_HEIGHT_ENUM } from './utils/tableUtils'

export default {
  name: 'CardTable',
  components: {
    PageBtn,
    HcToggleButton,
    HcButtonSvg,
  },
  props: {
    isAutoGetData: { // 是否用内置方法获取数据
      type: Boolean,
      default: true
    },
    initFuc: { // mounted后执行一次的初始化回调方法
      type: Function,
      default: null,
    },
    getTableData: { // 获取数据方法
      type: Function,
    },
    pageSizes: {
      type: Array,
      default: undefined,
    },
    page: {
      type: Object,
      default: () => {
        return {
          currentPage: 1,
          total: 0,
          pageSize: 50,
          pageSizes: [50, 100, 200],
        }
      },
    },
    tableConfig: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      loading: false,
      tableData: [],

      expand: false,
      tableCheckedRows: [], // 已选择的行
    }
  },
  computed: {
    // 已选择的行数
    tableCheckedRowsNum() {
      return this.tableCheckedRows.length
    },
    columnsInner() {
      let localColumns = this.tableConfig?.props?.columns
      if (this.tableConfig.rowSortable) {
        localColumns = [
          {
            field: '_rowSortable',
            fixed: 'left',
            width: 40,
            slots: {
              default() {
                return [
                  <i class="vxe-icon--menu row-sortable-btn"></i>
                ]
              }
            }
          },
          ...localColumns
        ]
      }
      return deepHandleColBeforeRender(localColumns)
    },
    fieldColumnInnerObj() {
      // 注意, 这里嵌套表格也会打平, 最终形成 {[field: string]: ICol}
      return this.flatColumnInner(this.columnsInner)
    },
    vxeGridHeaderCellClassName() {
      const headerCellClassNameParent = this.tableConfig?.props?.vxeGridHeaderCellClassName
      const headerCellClassNameDefault = ({ column }) => {
        const { field } = column
        const columnInner = this.fieldColumnInnerObj[field] || {}
        const { hcPreset = {} } = columnInner
        const { headerTopBarLevel } = hcPreset

        if (headerTopBarLevel) {
          return `g-vxe-grid__header-top-bar__level__${headerTopBarLevel}`
        }

        return ''
      }

      return headerCellClassNameParent || headerCellClassNameDefault
    },
    vxeGridHeaderCellStyle() {
      const headerCellStyleParent = this.tableConfig?.props?.headerCellStyle
      const headerCellStyleDefaul = ({ column }) => {
      }

      return headerCellStyleParent || headerCellStyleDefaul
    },
    isEnterVirtualScrollMode() {
      // 是否进入虚拟滚动的状态
      // 根据文档, 当 props.data.length > props.scrollX.gt(100)
      // props.columns.length > props.scrollY.gt(100) 会进入虚拟滚动模式
      // 先假设用户不会来更改 gt 这个值
      // 这里是个坑, 后面维护
      return this.tableData.length > 100 || this.columnsInner.length > 100
    },
  },
  watch: {
    tableData: {
      handler(val) {
        this.updatecheckedRows()
        if (!val || !isArray(val) || val.length === 0) {
          return
        }

        this.handleColAutoWidth()
      },
      immediate: true
    }
  },
  created() {
    this.mergePagination()
    this.initIntervalLogic() // 处理定时逻辑
  },
  destroyed() {
    this.intervalIdFlushTableData && clearInterval(this.intervalIdFlushTableData)
    this.sortable && this.sortable.destroy()
  },
  async mounted() {
    this.mainTable = this.$refs.mainTable
    if (this.isAutoGetData) {
      if (this.initFuc) await this.initFuc()

      if (this.tableConfig.customColumn) await this.getUserDefineRow()
      this.getData()
    }
    if (this.tableConfig.rowSortable) {
      this.rowDrop()
    }
    if (this.tableConfig.props?.sortConfig?.defaultSort) {
      // 代执行defaultSort初始排序
      this.$nextTick(() => {
        this.mainTable.sort(this.tableConfig.props.sortConfig.defaultSort)
      })
    }
  },
  methods: {
    composeVxeGridHeaderCellStyle(...args) {
      const localCell = ({ column }) => {
        const { headerHeightSize } = this.tableConfig
        const ret = {}

        if (headerHeightSize && TABLE_HEADER_HEIGHT_ENUM[headerHeightSize]) {
          ret.height = TABLE_HEADER_HEIGHT_ENUM[headerHeightSize].height
        }

        return ret
      }

      return composeFnObj([
        this.tableConfig?.props?.headerCellStyle,
        localCell,
      ])(...args)
    },
    composeVxeGridHeaderCellClassName(...args) {
      const localLogic = ({ column }) => {
        const { field } = column
        const columnInner = this.fieldColumnInnerObj[field] || {}
        const { hcPreset = {} } = columnInner
        const { headerTopBarLevel } = hcPreset

        if (headerTopBarLevel) {
          return `g-vxe-grid__header-top-bar__level__${headerTopBarLevel}`
        }

        return ''
      }

      return composeFnStrSpace([
        this.tableConfig?.props?.vxeGridHeaderCellClassName,
        localLogic,
      ])(...args)
    },
    composeVxeGridCellClassName(...args) {
      // 处理自动宽度的 className
      const localLogic = ({ column }) => {
        const { field } = column
        const columnInner = this.fieldColumnInnerObj[field] || {}
        const { hcPreset = {} } = columnInner
        const { autoWidth, autoWidthDom } = hcPreset

        if (autoWidth && autoWidthDom) {
          return `p__vxe-table__body__col__auto-adjustment-width p__vxe-td__field__${field}`
        }

        return ''
      }

      return composeFnStrSpace([
        this.tableConfig?.props?.cellClassName,
        localLogic,
      ])(...args)
    },
    composeVxeGridFooterCellClassName(...args) {
      // 处理自动宽度的 className
      const localLogic = ({ column }) => {
        const { field } = column
        const columnInner = this.fieldColumnInnerObj[field] || {}
        const { hcPreset = {} } = columnInner
        const { autoWidth, autoWidthDom } = hcPreset

        if (autoWidth || autoWidthDom) {
          return `p__vxe-table__body__col__auto-adjustment-width p__vxe-td__field__${field}`
        }

        return ''
      }

      return composeFnStrSpace([
        this.tableConfig?.props?.cellClassName,
        localLogic,
      ])(...args)
    },
    handleVxeGridScroll: debounce(function(event) {
      // todo 这里没有处理 万一用户也传入了 @scroll, 当前是不会调用用户传入的 @scroll
      // console.log('handleVxeGridScroll', event)

      // 如果已经进入虚拟滚动模式, 每次滚动要重新计算一下autoWidthDom 类型列的宽度
      if (this.isEnterVirtualScrollMode) {
        this.handleColAutoWidth(true)
      }
    }, 500),
    handleColAutoWidth(isOnlyAutoWidthDom = false) {
      this.$nextTick(() => {
        const startTimeStamp = new Date().getTime()
        const { isNeedRecomputeNextTick } = reComputeAutoWidth(this.$refs.mainTable, this.columnsInner, this.tableData, { isOnlyAutoWidthDom }) || {}
        if (isNeedRecomputeNextTick) {
          // 这里可能有死循环, 维护注意
          this.$nextTick(() => this.handleColAutoWidth(true))
        }
        const endTimeStamp = new Date().getTime()
        console.log(`自动宽度耗时 ${endTimeStamp - startTimeStamp}ms`)
      })
    },
    flatColumnInner(cols = []) {
      const ret = {}
      cols.forEach(col => {
        if (col.children) {
          Object.assign(ret, this.flatColumnInner(col.children))
        } else {
          ret[col.field] = col
        }
      })

      return ret
    },
    vxeGridCellClassName(...args) {
      let ret = ''
      const cellClassNameOriginal = this.tableConfig?.props?.cellClassName
      if (isFunction(cellClassNameOriginal)) {
        ret += ' ' + cellClassNameOriginal(...args)
      }

      // 处理自动宽度的 className
      const headerCellClassNameDefault = ({ column }) => {
        const { field } = column
        const columnInner = this.fieldColumnInnerObj[field] || {}
        const { hcPreset = {} } = columnInner
        const { autoWidth, autoWidthDom } = hcPreset

        if (autoWidth && autoWidthDom) {
          return `p__vxe-table__body__col__auto-adjustment-width p__vxe-td__field__${field}`
        }

        return ''
      }

      const extrClassName = headerCellClassNameDefault(...args)
      ret += ' ' + extrClassName

      return ret
    },
    async initTable() {
      if (this.tableConfig.customColumn) await this.getUserDefineRow()
    },
    clearCheckedRows() {
      this.tableCheckedRows = []
    },
    updatecheckedRows(event) {
      let checkedRows = this.mainTable?.getCheckboxRecords(true) || []
      if (this.tableConfig?.props?.checkboxConfig?.reserve) {
        const checkedReserveRows = this.mainTable?.getCheckboxReserveRecords(true) || []
        checkedRows = checkedRows.concat(checkedReserveRows)
      }
      this.tableCheckedRows = checkedRows
    },
    handleCheckboxChange(event) {
      this.updatecheckedRows(event)

      if (this.tableConfig?.methods?.checkboxChange) {
        // 调用parent 的 event handler
        this.tableConfig.methods.checkboxChange(event)
      }
    },
    handleCheckboxAllChange(event) {
      this.updatecheckedRows(event)

      if (this.tableConfig?.methods?.checkboxAll) {
        // 调用parent 的 event handler
        this.tableConfig.methods.checkboxAll(event)
      }
    },
    // 加载数据， 会重置表格状态
    reloadVxeGridData(data) {
      if (!this.$refs?.mainTable) {
        return
      }

      this.$refs.mainTable.reloadData(data || this.tableData || [])
    },
    // 加载数据， 不会重置表格状态
    loadVxeGridData(data) {
      if (!this.$refs?.mainTable) {
        return
      }

      this.$refs.mainTable.loadData(data || this.tableData || [])
    },
    async getUserDefineRow() {
      // 获取自定义列
      this.loading = true
      const { customColumn, hideCustomColSetting } = this.tableConfig
      const customColumnOptionsValues = Object.values(customColumn.options)
      let allRes = []
      if (hideCustomColSetting || !customColumn) {
        // 隐藏时使用自定义列写法不调用接口
        customColumnOptionsValues.forEach((item) => {
          allRes.push({})
        })
      } else {
        allRes = await Promise.all(
          customColumnOptionsValues.map((item) => {
            return this.$request(
              this.$api.common.getUserDefineRow,
              item.params
            )
          })
        )
      }
      const allEditList = []
      allRes.forEach(({ code, data }, index) => {
        const defaultColumnLinearArr = [] // 默认列信息转为一维数组
        customColumnOptionsValues[index].default.forEach((item) => {
          defaultColumnLinearArr.push(...item.children)
        })
        if (code === 200) {
          if (data?.jsonConfig) {
            // 有值赋值
            let jsonConfig = JSON.parse(data.jsonConfig)
            // 删除已经不在默认数据中的垃圾数据
            jsonConfig = jsonConfig.filter((item) => {
              if (defaultColumnLinearArr.find((k) => k.field === item.field)) {
                return true
              }
              return false
            })
            // 整合在默认数据中没有的值
            defaultColumnLinearArr.forEach((item) => {
              const findIndex = jsonConfig.findIndex(
                (k) => k.field === item.field
              )
              if (findIndex >= 0) {
                jsonConfig[findIndex].label = item.label // 防止名字更改
                jsonConfig[findIndex].disabled = item.disabled // 防止冻结项更改
                jsonConfig[findIndex] = { ...item, ...jsonConfig[findIndex] } // 防止因默认数据扩充而缺少字段，填充默认数据
              } else {
                jsonConfig.push(item)
              }
            })
            allEditList.push(jsonConfig)
            return
          }
        }
        // 无值或者接口失败取默认值
        allEditList.push(defaultColumnLinearArr)
      })
      this.editColumn(allEditList)
      this.loading = false
    },

    openHeaderDialog() {
      const { customColumn, props = {} } = this.tableConfig
      this.$dialog({
        width: 'middle2',
        isMaxHeight: true,
        component: () => (
          <SzEditTableHeader
            custom-column={customColumn}
            activeColumns={props.columns}
            onDone={this.editColumn}
          />
        ),
      })
    },
    editColumn(columnListArr) {
      // 修改列
      columnListArr.forEach((columnList, index) => {
        const options = Object.values(this.tableConfig.customColumn.options)
        let newColumns = []
        if (options[index].type === 'second') {
          // 是否为二级表头类型
          options[index].default.forEach((def) => {
            const newChildren = []
            def.children.forEach((child) => {
              const findObj = columnList.find(
                (item) => item.field === child.field
              )
              if (findObj?.enable) {
                const columnItemObj = {
                  field: findObj.field,
                  title: findObj.label,
                  fixed:
                    child.fixed === 1
                      ? 'left'
                      : child.fixed === 2
                        ? 'right'
                        : '',
                  ...options[index].defaultColumns[findObj.field],
                }
                newChildren.push(columnItemObj)
              }
            })
            if (def.isShowFirstGrade) {
              newColumns = [...newColumns, ...newChildren]
            } else if (newChildren.length) {
              newColumns.push({
                headerAlign: 'center',
                ...def,
                title: def.name,
                children: newChildren,
              })
            }
          })
        } else {
          columnList.forEach((column) => {
            if (!column.enable) return
            const findObj = options[index].defaultColumns[column.field]
            if (findObj) {
              const columnItemObj = {
                field: column.field,
                title: column.label,
                fixed:
                  column.fixed === 1
                    ? 'left'
                    : column.fixed === 2
                      ? 'right'
                      : '',
                ...findObj,
              }
              newColumns.push(columnItemObj)
            }
          })
        }
        options[index].edit = columnList
        options[index].editColumns = newColumns
      })
      this.tableConfig.customColumn.callBack()
    },
    onPageChange() {
      this.$sensors.setWebClick({ name: '表格点击-翻页' })
      this.$nextTick(() => {
        this.getData()
      })
    },
    reset() {
      this.page.currentPage = 1
      this.expand = false
      this.$nextTick(() => {
        this.getData()
      })
    },
    getData: debounce(
      async function() {
        try {
          if (!this.getTableData) return
          this.loading = true
          const { currentPage, pageSize } = this.page
          this.tableData = [] // 还原数据，同一个表格容器列字段改变会引发问题
          const res = await this.getTableData(currentPage, pageSize)
          if (!res) {
            this.loading = false
            return
          }
          const { tableData, total, nextTickCallBack = () => {} } = res
          this.tableData = tableData
          this.page.total = total
          this.$nextTick(() => nextTickCallBack())
        } finally {
          this.loading = false
        }
      },
      100
    ),
    async flushDataWithoutLoading() {
      try {
        const { currentPage, pageSize } = this.page
        const res = await this.getTableData(currentPage, pageSize)
        if (!res) {
          return
        }
        const { tableData, total } = res
        this.tableData = tableData
        this.page.total = total
        // setAllRowExpand()
      } catch (err) {
        console.log('无感刷新表格数据失败', err)
      }
    },
    initIntervalLogic() {
      const DEFAULT_INTERVAL = 1000 * 60 * 5 // 默认5分钟刷一次
      if (this.tableConfig.intervalFlushTableData) {
        this.intervalIdFlushTableData = setInterval(() => {
          this.flushDataWithoutLoading()
        }, this.tableConfig.intervalFlushTableData || DEFAULT_INTERVAL)
      }
    },

    // 合并 page config
    mergePagination() {
      const { page, pageSizes } = this
      Array.isArray(pageSizes) &&
        pageSizes.length > 0 &&
        (page.pageSizes = pageSizes)
    },

    getIndex(index) {
      const { pageSize, currentPage } = this.page
      return pageSize * (currentPage - 1) + index + 1
    },

    getCheckboxRecords() {
      return this.tableCheckedRows
    },
    rowDrop() {
      this.$nextTick(() => {
        this.sortable = Sortable.create(this.mainTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'), {
          handle: '.row-sortable-btn',
          onEnd: ({ newIndex, oldIndex }) => {
            const currRow = this.tableData.splice(oldIndex, 1)[0]
            this.tableData.splice(newIndex, 0, currRow)
          }
        })
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.table-layout-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  .actions-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 0 0 12px;
    .left-action {
      margin-top: 15px;
    }
    .sz-rightActions-box {
      margin-left: auto;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .inline-btn {
        margin-left: 12px;
        font-size: 14px;
        line-height: 30px;
        padding: 0 8px;
      }
    }
  }
  ::v-deep .row-sortable-btn {
    cursor: move;
  }
  ::v-deep .vxe-body--row.sortable-ghost, .vxe-body--row.sortable-chosen{
    background-color: #dfecfb;
  }
  .page-box {
    display: flex;
    justify-content: space-between;
    padding: 12px 0;
  }
  // form样式
  ::v-deep .config-form-box {
    margin-top: 12px;
  }
}

.icon-button {
  color: $G7;
}
</style>

<style>
.vxe-table--render-default .vxe-body--column.p__vxe-table__body__col__auto-adjustment-width .vxe-cell,
.vxe-table--render-default .vxe-footer--column.p__vxe-table__body__col__auto-adjustment-width .vxe-cell {
  /* 宽度固定的场景才有效, 表格中是这样的 */

  /* 不允许换行 */
  white-space: nowrap;
  /* 文字切割 */
  word-break: normal;
  /* 超出部分隐藏, 可以通过 $0.scollWidth > $0.offsetWidth 判断内容超过了容器宽度 */
  overflow: hidden;
  /* 文字超过部分 ... */
  text-overflow: ellipsis;
}
</style>
